import { render, staticRenderFns } from "./WaiZhaoLiuShuiXianKanban.vue?vue&type=template&id=0ca98ae3&"
import script from "./WaiZhaoLiuShuiXianKanban.vue?vue&type=script&lang=js&"
export * from "./WaiZhaoLiuShuiXianKanban.vue?vue&type=script&lang=js&"
import style0 from "./WaiZhaoLiuShuiXianKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports